import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from '@resurs/midas-react'

import { getText } from '../../../internal/TextLabels'

const ResetPasswordModal = props => {
  useEffect(() => {
    if (props.reset && props.temporaryPassword === '') {
      props.onClose()
    }
  }, [props.reset])

  const getDescText = () => {
    if (props.user.email) {
      return (
        <p>
          {`${props.user.firstName} ${getText('user.editPassword.descEmail')} ${
            props.user.email
          }`}
        </p>
      )
    }
    return (
      <p>
        {props.user.firstName} {getText('user.editPassword.descTemporary')}
      </p>
    )
  }

  const handleDownload = user => {
    if (props.temporaryPassword) {
      const content = `${props.user.username}: ${props.temporaryPassword}`

      const blob = new Blob([content], { type: 'text/plain' })

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'password.txt')
        return null
      }

      return (
        <a
          download={`temporary-password-${user.username}.txt`}
          href={window.URL.createObjectURL(blob)}
        >
          {getText('default.saveFile')}
        </a>
      )
    }
    return null
  }

  const { user, temporaryPassword, loading, onReset, onClose } = props
  return (
    <Modal
      show
      title={getText('user.editPassword.reset')}
      onClose={() => onClose()}
      hideClose
      actions={
        <Button type="link" onClick={() => onClose()}>
          {getText('default.close')}
        </Button>
      }
    >
      <div>
        {temporaryPassword ? (
          <div
            style={{
              display: 'block',
              margin: '0 auto',
              textAlign: 'center',
            }}
          >
            <strong>{getText('user.editPassword.new')}</strong>
            <p>
              <code>{temporaryPassword}</code>
            </p>
            {handleDownload(user)}
          </div>
        ) : (
          <div
            style={{
              display: 'block',
              margin: '0 auto',
              textAlign: 'center',
            }}
          >
            {getDescText()}
            <Button
              text={getText('user.editPassword.reset')}
              type="primary"
              loading={loading}
              onClick={e => {
                e.preventDefault()
                onReset(e, user)
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}

ResetPasswordModal.propTypes = {
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  temporaryPassword: PropTypes.string,
  reset: PropTypes.bool, //eslint-disable-line
  onReset: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

ResetPasswordModal.defaultProps = {
  loading: false,
  temporaryPassword: '',
  reset: false,
}

export default ResetPasswordModal
